export default __webpack_public_path__ + "static/media/hero.3e9e07da.jpeg";